import descarga from "./../../assets/images/svg/descarga.svg"
import biblioteVirtual from "./../../assets/images/svg/biblioteca-virtual.svg"
import lecturaOnline from "./../../assets/images/svg/lectura-online.svg"
import { useEffect,useState } from "react";
import axios from "axios";
import { capitulosDTO } from "../../models/Colecciones.model";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import cita from "./../../assets/images/svg/cita.svg"
import { pathImages, webApiCapitulos } from "../../routes/endpoints";
import { Link,useParams } from "react-router-dom"
import { base_pdf, base_url_completa} from "../../constants"
import { propsBotonesAccion } from "../../models/Obras.model"
import Alertas from "../../utilities/Alertas";

export default function BotonesAccion(props: propsBotonesAccion) { 

    const { id } = useParams() as { id: any; }
    const [capiutulos, setCapitulos] = useState<capitulosDTO[]>([]);
    const [textoCita, setTextoCita] = useState('')
    let apa = '';
    useEffect(()=>{  
        window.scrollTo(0, 0)
        axios.post(webApiCapitulos, { id:id  } ).then((response) => {  
            setCapitulos(response.data);                                                    
        }).catch(err => console.warn(err));
        setTextoCita(stripHTMLTags(props.apa))            
    },[id]) 
    
    function stripHTMLTags(html:string) {
        const parseHTML = new DOMParser().parseFromString(html, 'text/html');
        return parseHTML.body.textContent || '';
      } 

    if(props.tipo ===1){         
        return(
            <>    
            <Link to={{  pathname: `${base_url_completa}/pdf/${props.id}` }} target="_parent" rel="noopener noreferrer">
                <button className=" btn_order_general text-center justify-content-center d-flex align-items-center"><img
                    src={descarga} alt="descargar" className="" height="42px"/>
                    <p className="mb-0 ms-2">Lectura en línea</p>
                </button>
            </Link>
            <CopyToClipboard text={textoCita}> 
                <button className="mt-2 btn_order_general text-center justify-content-center d-flex align-items-center" onClick={ () =>Alertas('Datos de la obra copiados correctamente')}><img
                        src={cita} alt="citar" className="" height="42px"/>
                    <p className="mb-0 ms-2">Citar esta obra</p>
                </button>
            </CopyToClipboard>
            </>
        )
    }else{
        return(
            <>      
                <div className="col-md-4 px-0">
                    <div className="me-md-2">  
                    {(props.archivo !== null)?
                    <Link to={{  pathname: `${base_pdf}${props.archivo}` }} target="_blank" rel="noopener noreferrer" download>
                        <button className="btn_order_general text-left justify-content-center d-flex align-items-center"><img
                            src={descarga} alt="descargar" className="" height="42px"/>
                            <p className="mb-0 ms-2">Descargar obra completa</p>
                        </button>
                    </Link>:<button className="btn_order_general text-left justify-content-center d-flex align-items-center botonDisabled" disabled><img
                            src={descarga} alt="descargar" className="" height="42px"/>
                            <p className="mb-0 ms-2">Descargar obra completa</p>
                        </button>}
                    </div>
                </div>   

                <div className="col-md-4 px-0 mt-2 mt-md-0">
                    <div className="me-md-2">  

                    {(capiutulos.length>0)?
       
                    
                        <button className="btn_order_general text-left justify-content-center d-flex align-items-center  " data-bs-toggle="collapse" data-bs-target="#demo"><img
                            src={descarga} alt="descargar" className="" height="42px"/>
                            <p className="mb-0 ms-2">Descargar por capítulos</p>
                        </button>
                    :
                    <button className="btn_order_general text-left justify-content-center d-flex align-items-center botonDisabled "><img
                        src={descarga} alt="descargar" className="" height="42px"/>
                            <p className="mb-0 ms-2">Descargar por capítulos</p>
                        </button>
                    }


                    </div>
                </div> 
                <div className="col-md-4 px-0 mt-2 mt-md-0">
                    <div> 
                    <button className="btn_order_general text-left justify-content-center d-flex align-items-center botonDisabled" disabled><img
                            src={biblioteVirtual} alt="biblioteca virtual" className="" height="42px"/>
                        <p className="mb-0 ms-2">Biblioteca virtual</p>
                    </button>
                    </div>
                </div> 
                <div id="demo" className="collapse mt-1">
                    <div className="contenedorCapitulos" >
                    <ul>
                    { capiutulos?.map( (cap, i) =>     
                        
                         <li className="listaCapitulos"><Link to={{  pathname: `${base_pdf}${cap.archivo}` }} target="_blank" rel="noopener noreferrer" download><button className=" btn_capitulos d-none d-sm-inline-block" >{cap.nombre}</button></Link></li>
                        )
                    }    
                    </ul>

                    </div>
                </div>
            </>
        )

    }
}